import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getFileStatus } from '../store/actions/import_object';

export class FileStatus extends React.Component {
  static propTypes = {
    file: PropTypes.object.isRequired,
    getFileStatus: PropTypes.func.isRequired
  }

  componentDidMount() {
    const { getFileStatus, file } = this.props;
    this.timer = setInterval(() => getFileStatus(file), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
    this.timer = null;
  }

  render() {
    return null;
  }
}

const mapDispatchToProps = {
  getFileStatus
};

export default connect(() => ({}), mapDispatchToProps)(FileStatus);